import { useSearchParams } from 'react-router-dom';
import { BannerNotificationFilter } from '../constants/banner-notification-filter.enum';
import { Button } from '../../../ui/components/ui/button';
import FilterIcon from '../../../ui/components/icons/filter-icon';
import { useEffect } from 'react';

export const isValidFilter = (urlFilter?: string | null): boolean => {
  return !!(urlFilter && Object.values(BannerNotificationFilter).includes(urlFilter as BannerNotificationFilter));
};

interface BannerFilterProps {
  paramName?: string;
  defaultValue?: BannerNotificationFilter;
  onFilterChange?: (filter: BannerNotificationFilter) => void;
  onFilterSearchParamsChange?: (searchParams: URLSearchParams) => URLSearchParams;
}

const BannerFilter = ({
  paramName = 'filter',
  defaultValue = BannerNotificationFilter.CURRENT,
  onFilterChange,
  onFilterSearchParamsChange
}: BannerFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlFilter = searchParams.get(paramName);
  const currentFilter = isValidFilter(urlFilter) ? (urlFilter as BannerNotificationFilter) : defaultValue;

  const activeFilter = currentFilter === BannerNotificationFilter.CURRENT;
  const pastFilter = currentFilter === BannerNotificationFilter.PAST;

  useEffect(() => {
    const isValid = isValidFilter(urlFilter);

    if (isValid) return;

    setSearchParams(
      (prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.set(paramName, defaultValue);
        return newParams;
      },
      { replace: true }
    );
  }, [defaultValue, paramName, setSearchParams, urlFilter]);

  const handleFilterChange = (newFilter: BannerNotificationFilter) => {
    if (newFilter === currentFilter) return;

    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set(paramName, newFilter);
      return onFilterSearchParamsChange?.(newParams) ?? newParams;
    });

    onFilterChange?.(newFilter);
  };

  return (
    <div className="flex gap-3">
      <Button
        variant={activeFilter ? 'default' : 'outline'}
        className="flex gap-3 items-center rounded-2xl px-3 py-2 border text-sm"
        onClick={() => handleFilterChange(BannerNotificationFilter.CURRENT)}>
        <FilterIcon active={activeFilter} />
        Aktive & Zukünftige Banner
      </Button>
      <Button
        variant={pastFilter ? 'default' : 'outline'}
        className="flex gap-3 items-center rounded-2xl px-3 py-2 border text-sm"
        onClick={() => handleFilterChange(BannerNotificationFilter.PAST)}>
        <FilterIcon active={pastFilter} />
        Vergangene Banner
      </Button>
    </div>
  );
};

export default BannerFilter;
